(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (function() {
    function initSeeMore() {
      document.querySelectorAll('[data-see-more-block]:not([data-initialized])').forEach(function(block) {
        block.setAttribute('data-initialized', '');

        var btn = block.querySelector('[data-see-more-btn]');
        var content = block.querySelector('[data-see-more-content]');
        var textBlock = block.querySelector('.text-block');
        var label = block.querySelector('[data-see-more-label]');
        var labelMore = btn.getAttribute('data-label-more');
        var labelLess = btn.getAttribute('data-label-less');

        // Read percentage from data attribute
        var percent = parseInt(block.getAttribute('data-percent')) || 30;

        // Measure full height then calculate collapsed height from percentage
        var fullHeight = textBlock.scrollHeight;
        block.style.setProperty('--see-more-full-height', fullHeight + 'px');

        var lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 24;
        var collapsedHeight = Math.max(Math.ceil(fullHeight * percent / 100), lineHeight * 2);
        block.style.setProperty('--see-more-height', collapsedHeight + 'px');
        block.setAttribute('data-expanded', 'false');

        btn.addEventListener('click', function() {
          var isExpanded = block.getAttribute('data-expanded') === 'true';

          if (isExpanded) {
            block.setAttribute('data-expanded', 'false');
            btn.setAttribute('aria-expanded', 'false');
            label.textContent = labelMore;
          } else {
            // Re-measure in case of dynamic content
            block.style.setProperty('--see-more-full-height', textBlock.scrollHeight + 'px');
            block.setAttribute('data-expanded', 'true');
            btn.setAttribute('aria-expanded', 'true');
            label.textContent = labelLess;
          }
        });
      });
    }

    // Init on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSeeMore);
    } else {
      initSeeMore();
    }

    // Re-init on Shopify section events (theme editor)
    document.addEventListener('shopify:section:load', initSeeMore);
    document.addEventListener('shopify:block:select', initSeeMore);
  })();
  } catch(e) { console.error(e); }
})();

})();
